import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { el } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';

/**
 * Date Picker with Manual Input Component
 * Features:
 * - Πεδίο χειροκίνητης καταχώρησης ημερομηνίας (ηη/μμ/εεεε)
 * - Ημερολόγιο inline
 * - Ελληνική γλώσσα
 */
const DatePickerWithInput = ({ 
  selected, 
  onChange, 
  inline = true,
  minDate = null,
  className = "",
  ...props 
}) => {
  // Manual input state
  const [manualInput, setManualInput] = useState('');
  
  // Sync manual input with selected date
  useEffect(() => {
    if (selected) {
      const date = new Date(selected);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      setManualInput(`${day}/${month}/${year}`);
    } else {
      setManualInput('');
    }
  }, [selected]);

  // Handle manual input change
  const handleManualInputChange = (e) => {
    const inputValue = e.target.value;
    setManualInput(inputValue);
    
    // Try to parse the date (format: dd/mm/yyyy)
    const parts = inputValue.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      
      if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= 2100) {
        const date = new Date(year, month - 1, day);
        if (!isNaN(date.getTime())) {
          onChange(date);
        }
      }
    }
  };

  return (
    <div className="space-y-2">
      {/* Manual input field */}
      <input
        type="text"
        value={manualInput}
        onChange={handleManualInputChange}
        placeholder="ηη/μμ/εεεε"
        className="w-full h-8 px-3 py-1 border border-slate-300 rounded-md bg-white text-slate-900 text-sm focus:outline-none focus:ring-0 focus:border-slate-400"
        name={`dp-${Math.random().toString(36).slice(2, 10)}`}
        autoComplete="new-password"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        data-form-type="other"
        data-lpignore="true"
        data-1p-ignore="true"
        data-bwignore="true"
        aria-autocomplete="none"
      />
      {/* Calendar picker - centered */}
      <div className="flex justify-center">
        <DatePicker
          selected={selected}
          onChange={onChange}
          dateFormat="dd/MM/yyyy"
          locale={el}
          inline={inline}
          minDate={minDate}
          fixedHeight
          calendarClassName="small-calendar"
          {...props}
        />
      </div>
    </div>
  );
};

export default DatePickerWithInput;
